export const TOGGLE_BOXED_LAYOUT = 'TOGGLE_BOXED_LAYOUT';
export const SHOW_GROWL_MESSAGE = 'SHOW_GROWL_MESSAGE'

export const LOGIN_USER_DATA='LOGIN_USER_DATA';


